// extracted by mini-css-extract-plugin
export default {"image":"Q0-z","loaded":"R0-z"};